import { render, staticRenderFns } from "./ad-card.vue?vue&type=template&id=6a39a22e&scoped=true&"
import script from "./ad-card.vue?vue&type=script&lang=js&"
export * from "./ad-card.vue?vue&type=script&lang=js&"
import style0 from "./ad-card.vue?vue&type=style&index=0&id=6a39a22e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a39a22e",
  null
  
)

export default component.exports